export enum TableType {
  USER_EDIT = 'userEdit',
  ORDER_VIEW = 'orderView',
  USER_ORDERS = 'userOrders',
  USER_PURCHASES = 'userPurchases',
  USER_STATISTICS = 'userStatistics',
  USED_COUPON_DETAILS = 'usedCouponDetails',
}
